import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    GET_RECEIPT_DETAIL,
    GET_RECEIPT_DETAIL_SUCCESS,
    GET_RECEIPT_DETAIL_ERROR,
}
    from "../../actions/payment"

function* getReceiptDetailSaga(action) {
    try {
       const data  = yield call(paymentService.GetReceiptDetail,action.payload)
       yield put({
        type: GET_RECEIPT_DETAIL_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: GET_RECEIPT_DETAIL_ERROR,error: error.data
        })
    }
}


export function* getReceiptDetailSagaWatcher() {
    yield takeLatest(GET_RECEIPT_DETAIL, getReceiptDetailSaga)
}